import { GText } from '@shared-ui/components/ui/text'
import { Pressable, type StyleProp, type ViewStyle } from 'react-native'
import { useCreateStyles } from './styles'

export type AmountChipProps = {
  label: string
  onPress: () => void
  disabled?: boolean
  style?: StyleProp<ViewStyle>
  testID?: string
}

export function AmountChip({ label, onPress, disabled, style, testID }: AmountChipProps) {
  const styles = useCreateStyles()
  return (
    <Pressable
      accessibilityRole="button"
      disabled={disabled}
      onPress={onPress}
      testID={testID}
      style={[styles.root, style]}
    >
      <GText variant="body-16-semibold" style={disabled ? styles.disabled : undefined}>
        {label}
      </GText>
    </Pressable>
  )
}
